import { Grid, Typography } from '@mui/material'
import React from 'react'

import useStyles from './useStyles'

import DesktopWindowsOutlinedIcon from '@mui/icons-material/DesktopWindowsOutlined'
import StayCurrentPortraitOutlinedIcon from '@mui/icons-material/StayCurrentPortraitOutlined'
import DeviceUnknownOutlinedIcon from '@mui/icons-material/DeviceUnknownOutlined'

export const SessionsList = ({ sessions, setuuidDeviceSessions, handleOpenModalDeleteSessions }) => {
  const classes = useStyles()

  const handleDeleteSession = (uuidDeviceSession) => {
    if (!uuidDeviceSession) return console.log('uuidDeviceSession nulo')
    setuuidDeviceSessions([uuidDeviceSession])
    handleOpenModalDeleteSessions()
  }

  const getIconDevice = (session) => {
    if (!session || !session?.clientArchInfo?.deviceModel) {
      return (
        <DeviceUnknownOutlinedIcon
          style={{ fontSize: '3rem', color: '#485450', padding: 10 }}
        />
      )
    }
    const { deviceModel } = session.clientArchInfo

    return deviceModel.includes('Android') ||
      deviceModel.includes('iOS') ||
      deviceModel.includes('ipadOS') ||
      deviceModel.includes('iPhone OS')
      ? (
      <StayCurrentPortraitOutlinedIcon
        style={{ fontSize: '3rem', color: '#485450', padding: 10 }}
      />
        )
      : (
      <DesktopWindowsOutlinedIcon
        style={{ fontSize: '3rem', color: '#485450', padding: 10 }}
      />
        )
  }

  const device = (session) => {
    if (!session) return console.log('no se encontro sesion')
    const { deviceModel } = session.clientArchInfo
    if (!deviceModel) return 'Dispositivo no definido'
    if (
      deviceModel.includes('Android') ||
      deviceModel.includes('iOS') ||
      deviceModel.includes('ipadOS') ||
      deviceModel.includes('iPhone OS')
    ) {
      return 'Dispositivo celular'
    } else {
      return 'Computadora de escritorio'
    }
  }
  const ubication = (session) => {
    if (!session) return console.log('no se encontro sesion')
    const { clientLocalizationInfo } = session
    return `${clientLocalizationInfo.city}, ${clientLocalizationInfo.region}, ${clientLocalizationInfo.country}`
  }

  if (!sessions || sessions.length === 0) {
    return (
      <div
        style={{
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}
      >
        <Typography
          style={{
            fontSize: 16,
            padding: 10,
            fontWeight: 'bold',
            color: '#485450'
          }}
        >
          No se encontraron sesiones activas
        </Typography>
      </div>
    )
  }

  return (
    <>
      {sessions &&
        sessions.map((item) => (
          <Grid key={item.uuidDeviceSession} container style={{ padding: 10 }}>
            <Grid
              item
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
              }}
            >
              {getIconDevice(item)}
            </Grid>
            <Grid item xs={8}>
              <Typography
                style={{
                  fontSize: 16,
                  fontWeight: 'bold',
                  color: '#485450'
                }}
              >
                {device(item)}
              </Typography>
              <div style={{ display: 'flex' }}>
                <Typography
                  style={{
                    fontSize: 13,
                    fontWeight: 'bold',
                    color: '#6e7a76'
                  }}
                >
                  Dispositivo:
                </Typography>
                <Typography
                  style={{
                    fontSize: 13,
                    fontWeight: 'bold',
                    color: '#485450',
                    paddingLeft: 2
                  }}
                >
                  {item.clientArchInfo.deviceModel}
                </Typography>
              </div>
              <div style={{ display: 'flex' }}>
                <Typography
                  style={{
                    fontSize: 13,
                    fontWeight: 'bold',
                    color: '#6e7a76'
                  }}
                >
                  Navegador:
                </Typography>
                <Typography
                  style={{
                    fontSize: 13,
                    fontWeight: 'bold',
                    color: '#485450',
                    paddingLeft: 2
                  }}
                >
                  {item.clientAgentInfo.name || ''} {item.clientAgentInfo.version && 'versión ' + item.clientAgentInfo.version} {item.clientAgentInfo.language && 'idioma ' + item.clientAgentInfo.language}
                </Typography>
              </div>
              <div style={{ display: 'flex' }}>
                <Typography
                  style={{
                    fontSize: 13,
                    fontWeight: 'bold',
                    color: '#6e7a76'
                  }}
                >
                  Ubicación:
                </Typography>
                <Typography
                  style={{
                    fontSize: 13,
                    fontWeight: 'bold',
                    color: '#485450',
                    paddingLeft: 2
                  }}
                >
                  {ubication(item)}
                </Typography>
              </div>
              <div style={{ display: 'flex' }}>
                <Typography
                  style={{
                    fontSize: 13,
                    fontWeight: 'bold',
                    color: '#6e7a76'
                  }}
                >
                  IP del dispositivo:
                </Typography>
                <Typography
                  style={{
                    fontSize: 13,
                    fontWeight: 'bold',
                    color: '#485450',
                    paddingLeft: 2
                  }}
                >
                  {item.clientLocalizationInfo.ip}
                </Typography>
              </div>

            </Grid>
            <Grid
              item
              xs={2}
              style={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'center'
              }}
            >
              {/* setuuidDeviceSession */}
              <button
                className={classes.buttonDelete}
                onClick={() => handleDeleteSession(item.uuidDeviceSession)}
              >
                <Typography
                  className={classes.typographyButton}
                  style={{
                    color: '#263057'
                  }}
                >
                  Eliminar
                </Typography>
              </button>
            </Grid>
          </Grid>
        ))}

    </>
  )
}
